
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {Group, Cell, XButton},
data () {
return {
msg: 'Hello World!'
}
},
methods: {
goc () {
this.$http.post('/khdtest.asmx/CusChild', {
userid: this.bus.userid
}).then(function (resp) {
let tmp = JSON.parse(resp.data.d)
console.log('CusChild(response):', resp)
for (let item in tmp) {
console.log('CusChild - ' + item + ':', tmp[item])
}
}).catch(function (err) {
console.log(err)
})
},
gobase () {
this.$http.post('/khdtest.asmx/CusBaseList', {
userid: this.bus.userid
}).then(function (resp) {
console.log('CusBaseList(response):', resp)
let tmp = JSON.parse(resp.data.d)
for (let item in tmp) {
console.log('CusBaseList item:', tmp[item])
}
}).catch(function (err) {
console.log(err)
})
},
god () {
this.$http.post('/khdtest.asmx/Delivery', {
UName: this.bus.uname,
Pwd: this.bus.password,
fcno: '',
ctno: '011626003',
djno: '',
start: '2017-08-20',
end: '2017-11-20'
}).then(function (resp) {
let tmp = JSON.parse(resp.data.d)
console.log('Delivery(response):', resp)
console.log('Delivery:', tmp)
}).catch(function (err) {
console.log(err)
})
},
gobus () {
console.log('userid:', this.bus.userid)
console.log('uname:', this.bus.uname)
console.log('upwd:', this.bus.upwd)
console.log('password:', this.bus.password)
}
},
created () {
console.log('created')
}
}



// WEBPACK FOOTER //
// ./src/components/Hello.vue